module.exports = __webpack_public_path__ + "img/2-fr.e1e40509.jpg";